import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { forwardRef } from 'react';
/**
 * Button primitive. Emits `data-ui-button` and `data-variant`; the host
 * app's stylesheet maps those attributes to design tokens (see
 * `apps/web/src/styles.css` and `docs/design-system.md`). No hard-coded
 * colours live in this file or its consumers.
 *
 * Forwards the underlying `<button>` ref so callers can focus the
 * button programmatically (e.g. the sidebar drawer's close button).
 */
export const Button = forwardRef(function Button(props, ref) {
    const { variant = 'primary', type = 'button', children, ...rest } = props;
    return (_jsx("button", { ref: ref, "data-ui-button": "", "data-variant": variant, type: type, ...rest, children: children }));
});
//# sourceMappingURL=Button.js.map